import React, { useEffect, useState } from 'react';
import { getAmcList, getAmcRateCard } from '../api/squareyards';

const AmcBrokerageRates = () => {
  const [amcList, setAmcList] = useState([]);
  const [selectedAmcId, setSelectedAmcId] = useState('');
  const [rateCard, setRateCard] = useState(null);
  const [loadingList, setLoadingList] = useState(true);
  const [loadingRateCard, setLoadingRateCard] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    getAmcList()
      .then((list) => {
        setAmcList(list);
        if (list.length) {
          setSelectedAmcId(String(list[0].Id));
        }
      })
      .catch(() => setError('Unable to load AMC list. Please try again later.'))
      .finally(() => setLoadingList(false));
  }, []);

  useEffect(() => {
    if (!selectedAmcId) return;
    setLoadingRateCard(true);
    setError('');
    getAmcRateCard(selectedAmcId)
      .then((data) => setRateCard(data))
      .catch(() =>
        setError('Unable to load brokerage rates for this AMC. Please try again later.')
      )
      .finally(() => setLoadingRateCard(false));
  }, [selectedAmcId]);

  return (
    <div className='wrapper inner-page container' id='amc-brokerage-rates'>
      <section className='amc-brokerage-rates'>
        <h3 className='privacy-header'>AMC Brokerage Rates</h3>

        <div className='amc-select-row'>
          <label htmlFor='amc-select' className='footerpara footerpara-heading'>
            Select AMC
          </label>
          <select
            id='amc-select'
            className='amc-select'
            value={selectedAmcId}
            disabled={loadingList || !amcList.length}
            onChange={(e) => setSelectedAmcId(e.target.value)}
          >
            {amcList.map((amc) => (
              <option key={amc.Id} value={amc.Id}>
                {amc.AmcName}
              </option>
            ))}
          </select>
        </div>

        {loadingList && <p className='footerpara'>Loading AMC list…</p>}
        {error && <p className='footerpara amc-error'>{error}</p>}

        {!loadingList && !error && loadingRateCard && (
          <p className='footerpara'>Loading brokerage rates…</p>
        )}

        {!loadingRateCard && rateCard && (
          <>
            <div className='amc-rate-card-heading'>
              <h4>{rateCard.AmcName}</h4>
              {rateCard.DataMonth && (
                <span className='amc-data-month'>
                  Data as of {rateCard.DataMonth}
                </span>
              )}
            </div>

            {rateCard.Message && (
              <p className='footerpara amc-info'>{rateCard.Message}</p>
            )}

            {(!Array.isArray(rateCard.Product) ||
              rateCard.Product.length === 0) &&
              !rateCard.Message && (
                <p className='footerpara amc-info'>
                  No brokerage rate data available for this AMC.
                </p>
              )}

            {Array.isArray(rateCard.Product) && rateCard.Product.length > 0 && (
              <div className='amc-rate-card-table-wrapper'>
                <table className='amc-rate-card-table'>
                  <thead>
                    <tr>
                      <th>Scheme</th>
                      <th>Trail 1Y</th>
                      <th>Trail 2Y</th>
                      <th>Trail 3Y</th>
                      <th>Trail 4Y</th>
                      <th>B30 Incentive</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rateCard.Product.map((product) => (
                      <tr key={product.ProductID}>
                        <td>{product.ProductName}</td>
                        <td>{product.Trail1Y}</td>
                        <td>{product.Trail2Y}</td>
                        <td>{product.Trail3Y}</td>
                        <td>{product.Trail4Y}</td>
                        <td>{product.B30Incentive}</td>
                        <td>{product.status}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </section>
    </div>
  );
};

export default AmcBrokerageRates;
